// Consumer price index (1982-84 = 100), keyframes per DESIGN §6.2 plus a few extra
// pioneer-era points so the Civil War inflation and the long post-war deflation read right.
// Interpolated log-linearly between keyframes; clamped before 1859 and frozen after 2025.

export const CPI_KEYFRAMES = [
  [1859, 8.4],
  [1860, 8.5],
  [1862, 9.6],
  [1865, 15.0],
  [1870, 12.6],
  [1875, 11.0],
  [1880, 9.5],
  [1890, 8.9],
  [1900, 8.4],
  [1913, 9.9],
  [1920, 20.0],
  [1933, 13.0],
  [1945, 18.0],
  [1950, 24.1],
  [1960, 29.6],
  [1970, 38.8],
  [1980, 82.4],
  [1990, 130.7],
  [2000, 172.2],
  [2010, 218.1],
  [2020, 258.8],
  [2025, 320.0],
];

export const CPI_FREEZE_YEAR = 2025;

// year may be fractional (e.g. yearFrac(day)). Memoized (pure; hot: every era-dollar conversion calls it twice).
const CPI_MEMO = new Map();
export function cpi(year) {
  let v = CPI_MEMO.get(year);
  if (v === undefined) {
    if (CPI_MEMO.size > 8192) CPI_MEMO.clear();
    v = cpiRaw(year);
    CPI_MEMO.set(year, v);
  }
  return v;
}
function cpiRaw(year) {
  const k = CPI_KEYFRAMES;
  if (!(year > k[0][0])) return k[0][1];
  if (year >= k[k.length - 1][0]) return k[k.length - 1][1];
  for (let i = 1; i < k.length; i++) {
    const [y1, v1] = k[i];
    if (year <= y1) {
      const [y0, v0] = k[i - 1];
      const t = (year - y0) / (y1 - y0);
      return Math.exp(Math.log(v0) + t * (Math.log(v1) - Math.log(v0)));
    }
  }
  return k[k.length - 1][1];
}

export function inflate(amount, fromYear, toYear) {
  return amount * cpi(toYear) / cpi(fromYear);
}

export function to2025(amount, year) {
  return inflate(amount, year, CPI_FREEZE_YEAR);
}

// Era-dollar price for an item quoted in baseYear dollars, as shown in the shop in `year`.
export function priceIn(basePrice, baseYear, year) {
  return inflate(basePrice, baseYear, year);
}
